import React from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";

const MultiSelectList = ({ options, value, onChange }) => {
  const handleToggle = (id) => {
    const currentIndex = value.indexOf(id);
    const newChecked = [...value];

    if (currentIndex === -1) {
      newChecked.push(id);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    onChange(newChecked);
  };

  return (
    <Box >
      <List
        dense
        disablePadding
      >
        {options.map((option) => (
          <ListItem
            key={option.id}
            button
            onClick={() => handleToggle(option.id)}
            sx={{ py: 0 }} // compact spacing
          >
            <Checkbox
              edge="start"
              checked={value.indexOf(option.id) !== -1}
              tabIndex={-1}
              disableRipple
              size="small"
            />
            <ListItemText
              primary={option.name}
              sx={{ ml: 1 }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default MultiSelectList;
